import type { ReactNode } from "react";
import clsx from "clsx";
import TableContainer from "./TableContainer";
import TableHeader from "./TableHeader";
import type { DataTableColumn } from "./types";

type ResponsiveDataListProps<T> = {
  items: T[];
  columns: DataTableColumn[];
  getItemKey: (item: T) => string;
  renderMobileCard: (item: T) => ReactNode;
  renderDesktopRows: (item: T) => ReactNode;
  className?: string;
  mobileClassName?: string;
  desktopClassName?: string;
  tableClassName?: string;
};

const ResponsiveDataList = <T,>({
  items,
  columns,
  getItemKey,
  renderMobileCard,
  renderDesktopRows,
  className,
  mobileClassName,
  desktopClassName,
  tableClassName,
}: ResponsiveDataListProps<T>) => (
  <div className={className}>
    <div className={clsx("grid lg:hidden", mobileClassName ?? "gap-4")}>
      {items.map((item) => (
        <div key={getItemKey(item)}>{renderMobileCard(item)}</div>
      ))}
    </div>

    <TableContainer
      className={clsx(
        "hidden overflow-x-auto rounded-[1.75rem] border border-myteengig-border bg-white shadow-sm lg:block",
        desktopClassName,
      )}
    >
      <table className={clsx("min-w-full divide-y divide-myteengig-border", tableClassName)}>
        <TableHeader columns={columns} />
        <tbody className="divide-y divide-myteengig-border">
          {items.map((item) => renderDesktopRows(item))}
        </tbody>
      </table>
    </TableContainer>
  </div>
);

export default ResponsiveDataList;
